import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react'
import { Cropper } from 'react-cropper';
import 'cropperjs/dist/cropper.css'; //'

interface Props {
    imagePreview: any;
    setCropper: any;
}

const PhotoWidgetCropper = (prpos: Props) => {
    return (
        <Cropper 
            src={prpos.imagePreview}
            style={{height: 200, width: '100%'}}
            initialAspectRatio={1}
            aspectRatio={1}
            preview='.img-preview'
            guides={false}
            viewMode={1}
            autoCropArea={1}
            background={true}
            onInitialized={cropper => prpos.setCropper(cropper)}
        />
    );
}

export default observer(PhotoWidgetCropper);